import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false
}

export const visitorProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_VISITOR_PROFILE_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_VISITOR_PROFILE_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_VISITOR_PROFILE_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 